import { Div } from './Div';
import * as DomUtil from 'leaflet/src/dom/DomUtil';
import log from 'log';

export var Checkbox = Div.extend({

    initialize: function (latLngBounds, options, changeFunc) {
        Div.prototype.initialize.call(this, latLngBounds, options);
        var checkBox = DomUtil.create('input', 'myClass');
        checkBox.type = 'checkbox';
        if(changeFunc != undefined)
            checkBox.onchange = changeFunc;
        checkBox.style.width = '100%';
        checkBox.style.height = '100%';
        checkBox.style.margin = '0px';
        checkBox.style.position = 'absolute';
        checkBox.checked = false;
        this._elem = checkBox;
    },

    setHandler: function (on, func){
        this._elem.addEventListener(on, func);
    },

    getValue: function(){
        //log('Value: ' + this._elem.checked);
        return this._elem.checked;
    },

    setValue: function(newValue){
        log('Setting new value: ' + newValue);
        if(newValue === true)
            this._elem.checked = true;
        else if(newValue === false)
            this._elem.checked = false;
    },

    onAdd: function (map) {
        Div.prototype.onAdd.call(this, map);
        this._div.style.borderColor = 'red';
        this._div.appendChild(this._elem);
    }

});
